import styled from 'styled-components'

export interface ContainerProps {
  margin?: string
  fontFamily?: string
}

export interface HeaderProps {
  headerFontSize?: string
  headerLineHeight?: string
  headerColor?: string
  headerMargin?: string
  headerPadding?: string
  headerFontWeight?: string
}

export interface SubtitleProps {
  subtitleFontSize?: string
  subtitleLineHeight?: string
  subtitleColor?: string
}

export const Container = styled.div<ContainerProps>`
  width: 100%;
  display: flex;
  font-family: ${(props) => props.fontFamily || ''};
  margin: ${(props) => (props.margin ? props.margin : '40px 0 32px')};
`

export const Headings = styled.div`
  width: 100%;
`

export const Toolbox = styled.div``

export const Header = styled.h1<HeaderProps>`
  font-size: ${(props) =>
    props.headerFontSize ? props.headerFontSize : '28px'};
  line-height: ${(props) =>
    props.headerLineHeight ? props.headerLineHeight : '48px'};
  color: ${(props) => (props.headerColor ? props.headerColor : '#272142')};
  margin: ${(props) => (props.headerMargin ? props.headerMargin : '0 0 4px 0')};
  padding: ${(props) => (props.headerPadding ? props.headerPadding : '0')};
  font-weight: ${(props) =>
    props.headerFontWeight ? props.headerFontWeight : '600'};
`

export const Subtitle = styled.span<SubtitleProps>`
  font-size: ${(props) =>
    props.subtitleFontSize ? props.subtitleFontSize : '14px'};
  line-height: ${(props) =>
    props.subtitleLineHeight ? props.subtitleLineHeight : '20px'};
  color: ${(props) => (props.subtitleColor ? props.subtitleColor : '#767676')};
`
